// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { HasHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@store/MobiusOverrides/Link/Link";
import constants from "@store/constants";
import OrderChangeRequestLikelihood from "@store/Library/Components/OrderChangeRequest/OrderChangeRequestLikelihood";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: RequestOrderChangeButtonStyles;
}

export interface RequestOrderChangeButtonStyles {
    sendButton?: ButtonPresentationProps;
    wrapper?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        orderChangeRequestLink: getPageLinkByPageType(state, constants.pageType.reviewOrderChangeRequest),
        orderChangeRequestState: state.greif.pages.orderChange.changeRequestOrder,
    };
};

export const requestOrderChangeButton: RequestOrderChangeButtonStyles = {
    sendButton: {
        sizeVariant: "large",
    },
    wrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: ${pxToRem(10)};
        `,
    },
};

const styles = requestOrderChangeButton;

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

const RequestOrderChangeButton: FC<Props> = ({ orderChangeRequestLink, orderChangeRequestState }) => {
    const { value: order } = useContext(OrderStateContext);
    const [cannotProceedWithRequest, setCannotProceedWithRequest] = useState<boolean>(false);

    if (!order) {
        return null;
    }

    const { orderLines, newLines } = orderChangeRequestState;

    useEffect(() => {
        if (orderLines || newLines) {
            setCannotProceedWithRequest(
                orderLines.some(x => x.newQuantity <= 0 || !x.newQuantity) ||
                    (newLines ? newLines.some(x => x.newQuantity! <= 0 || !x.newQuantity) : false),
            );
        }
    }, [orderLines, newLines]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <OrderChangeRequestLikelihood />
            <Link href={`${orderChangeRequestLink?.url}?orderNumber=${order.id}`}>
                <Button
                    {...styles.sendButton}
                    data-test-selector="requestOrderChangeHeader_send"
                    disabled={cannotProceedWithRequest}
                >
                    {translate("Review Changes")}
                </Button>
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(RequestOrderChangeButton),
    definition: {
        group: constants.widgetGroup.orderChangeRequest,
        displayName: "Change Request Buttons",
        allowedContexts: ["OrderChangeRequestPage" as any],
    },
};

export default widgetModule;
